<div class="cnt-page-internal">
    <div class="row-title">
        <teiasoft-title [title]="'logs.title' | translate"></teiasoft-title>
    </div>
    <!-- TOOLBAR -->
    <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)"
        style="width: 100%;"></teiasoft-toolbar>

    <!-- GRID -->
    <teiasoft-grid-odata [columnsToHideGOD]="columnsToHide" [oDataUrl]="oDataUrl" [odataEntity]="'VLog'"
        [sortable]="true" [theme]="globals.theme!" style="width:100%" [selectable]="false" [disableAllSelection]="true"
        [filterable]="gridFilterable" [clearFilters]="clearFilters" [dateFormat]="globals.dateFormat!"
        [dateTimeFormat]="globals.dateTimeFormat!" [autoWidth]="true" [showSettingsDialog]="showSettingsDialog"
        (onCloseDialogSettings)="showSettingsDialog = false" (onUpdateConfiguration)="onUpdateConfiguration($event)"
        [gridConfiguration]="gridConfiguration" [autoWidth]="true" [refreshGridKey]="refreshGridKey"
        [columnsWidth]="columnsWidth" [paginable]="true" [rowsPerPage]="100" [resizableColumnRedistribute]="true">
    </teiasoft-grid-odata>

</div>